<template>
  <!-- Окно «договор отсутствует или истёк»: показывается аптекам при заходе на Главную,
       решает бэкенд (CompanyAgreement/MyStatus). Без «больше не показывать»: повторяется при каждом заходе. -->
  <v-dialog :value="value" max-width="600px" persistent @input="$emit('input', $event)">
    <v-card class="text-center">
      <v-card-title class="justify-center">
        Договор с ТОО “PharmIT”
      </v-card-title>
      <v-card-text>
        <v-icon large color="warning" class="mb-3">mdi-file-document-alert-outline</v-icon>
        <div class="body-1">
          Договор отсутствует или срок его действия истёк. Обратитесь к менеджеру ТОО “PharmIT” для перезаключения
        </div>
        <!-- договор заключается на БИН: перечисляем БИН без действующего договора -->
        <div v-if="bins && bins.length" class="body-2 mt-3">
          БИН без действующего договора: <strong>{{ bins.join(", ") }}</strong>
        </div>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary" text @click="$emit('input', false)">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AgreementWarning",
  props: {
    value: { type: Boolean, default: false },
    bins: { type: Array, default: () => [] },
  },
};
</script>
